import { z } from 'zod';

// ─── Common Primitives ───────────────────────────────────────────────────────

export const LocalizedStringSchema = z.object({
  th: z.string().default(''),
  en: z.string().default(''),
  zh: z.string().optional(),
  ru: z.string().optional(),
  ja: z.string().optional(),
  ko: z.string().optional(),
});
export type LocalizedString = z.infer<typeof LocalizedStringSchema>;

export const MoneySchema = z.object({
  amount: z.number().nonnegative(),
  currency: z.string().length(3).default('THB'),
});
export type Money = z.infer<typeof MoneySchema>;

export const TimestampFieldsSchema = z.object({
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});

export const SupportedLanguageSchema = z.enum(['th', 'en', 'zh', 'ru', 'ja', 'ko']);
export type SupportedLanguage = z.infer<typeof SupportedLanguageSchema>;
export type LanguageCode = SupportedLanguage;

export function getLocalizedText(
  text: LocalizedString | string | undefined | null,
  lang: SupportedLanguage = 'th'
): string {
  if (!text) return '';
  if (typeof text === 'string') return text;
  // Fallback chain: requested lang → en → th → first available
  return (text as Record<string, string>)[lang] || text.en || text.th || '';
}
